import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withAuctionCore } from 'agent';
import { observer } from 'mobx-react-lite';
import useStores from 'hooks/useStore';
import filterBrands from 'components/utils/filterBrands';
import VinDecodeDialog from 'components/VinDecodeDialog';
import {
  BarcodeContainer, VinInputWrapper, Row,
} from './styles';
import TextInput from '../forms/TextInput';
import Button from '../common/Button';

// JYAVP28E4EA005292 multiple
// 1HD1KGD10HB634496 single

const VinDecoder = observer(({
  auctioncore,
}) => {
  const { UIStore } = useStores();

  const {
    vin,
    setProperty,
    setLoading,
    setShowError,
    reset,
  } = UIStore;


  const populateYearMakeModel = async (data) => {
    const {
      vehicleYear, vehicleBrandID, vehicleModelID, vehicleModel, vehicleBrand,
    } = data;

    setProperty('year', vehicleYear);
    const brandResponse = await Promise.all([auctioncore.getPopularModels(), auctioncore.getVehicleBrands()]);
    const res = filterBrands(brandResponse);
    setProperty('makesList', res);
    const modelResponse = await auctioncore.getVehicleModels(vehicleYear, vehicleBrandID);
    setProperty('modelsList', modelResponse.data.lookupItems);

    setProperty('make', vehicleBrandID);
    setProperty('model', vehicleModelID);
    setProperty('makeName', vehicleBrand);
    setProperty('modelName', vehicleModel);
  };

  /** VIN Lookup */
  const VinDecode = async () => {
    // reset();

    let searchVin;
    try {
      setLoading(true);
      setProperty('multiVehicles', null);
      setProperty('year', null);
      setProperty('make', null);
      setProperty('model', null);
      setProperty('makeName', null);
      setProperty('modelName', null);

      switch (vin) {
        case 'HD':
          searchVin = '1HD1KRM19GB688406';
          break;
        case 'SXS':
          searchVin = '3NSNAE993LF133776';
          break;
        case 'SP':
          searchVin = 'JS1DM11B9H2100748';
          break;
        case 'MX':
          searchVin = 'JKAKXGHC2HA010797';
          break;
        default:
          searchVin = vin;
      }
      setProperty('vin', searchVin);
      const vinResponse = await auctioncore.doVinDecode(searchVin);

      console.log(vinResponse);

      if (vinResponse.data.items.length > 1) {

        setProperty('multiVehicles', vinResponse.data.items);
        setLoading(false);
        return;
      }



      const {
        vehicleYear, vehicleBrandID, vehicleBrand, vehicleModelID,
      } = vinResponse.data.items[0];

      if (!vehicleBrand) {
        setLoading(false);
        setShowError(true, 'Invalid VIN');
        return;
      }

      await populateYearMakeModel(vinResponse.data.items[0]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setShowError(true, error.response.data);
    }
  };

  useEffect(() => {
    const listener = (event) => {
      if (vin && vin.length > 14) {
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
          VinDecode();
          event.preventDefault();
        }
      }
    };
    if (vin && vin.length > 14) {
      document.addEventListener('keydown', listener);
    }
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [vin]);

  return (
    <div>

      <VinInputWrapper>
        <BarcodeContainer>
          <FontAwesomeIcon onClick={() => alert('Opens camera (where available)')} icon="barcode" color="black" />
        </BarcodeContainer>
        <TextInput placeholder="Enter your VIN" value={vin ? vin : ''} onChange={(e) => setProperty('vin', e.target.value)} />

      </VinInputWrapper>

      {vin && (
      <div style={{ display: 'flex', width: '100%' }}>
        <Button onClick={() => VinDecode()}>Decode VIN</Button>
      </div>
      )}
      <VinDecodeDialog populateYearMakeModel={populateYearMakeModel} />
    </div>
  );
});

VinDecoder.propTypes = {
  auctioncore: PropTypes.object.isRequired,
  setSelectedYear: PropTypes.func.isRequired,
  setSelectedBrand: PropTypes.func.isRequired,
  setSelectedModel: PropTypes.func.isRequired,
};

export default withAuctionCore(VinDecoder);
